// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"f321a976","453":"ca8d3389","455":"35af9380"}[chunkId] + ".chunk.js";
};